import type { Kitchen } from '@rta/rta-blueprint-library';

import type { BlueprintPage } from '../types';
import {
	COVER_BODY_STYLE,
	COVER_COYOTE_BOX_STYLE,
	COVER_DISCLAIMER_STYLE,
	COVER_IMAGE_PLACEHOLDER_STYLE,
	COVER_IMAGE_STYLE,
	COVER_IMAGE_WRAPPER_STYLE
} from './blueprint-cover-page.styles';
import { BlueprintPageFooter } from '../shared/blueprint-page-footer';
import { BlueprintPageHeader } from '../shared/blueprint-page-header';
import { BlueprintPageWrapper } from '../shared/blueprint-page-wrapper';
import { EditableText } from '../shared/editable-text';

export type BlueprintCoverPageProps = {
	page: BlueprintPage;
	kitchen: Kitchen;
	customerName?: string;
	layoutDescription?: string;
	designerName?: string;
	creationDate?: string;
	threeDImageUrl?: string;
};

const DISCLAIMER_LINE_1 = 'This is a computer-generated rendering of your island.';
const DISCLAIMER_LINE_2 = 'Countertop and panel colors vary, and actual color may not match photo.';
const DISCLAIMER_LINE_3 = 'Please verify countertop and panel finishes with your designer prior to approving your blueprints.';

const COYOTE_WARNING_TEXT = 'Coyote grills & cooking appliances require 7" behind the appliance to any non-combustible surface and 15" behind the appliance to any combustible surface.';

const COYOTE_WARNING_TEXT_2 = 'You cannot locate any Coyote grill or cooking appliance under any combustible material (pergolas, pavilions, etc.) without an approved ventilation hood. These requirements are specific to Coyote appliances so if you are using other appliances, you must refer to that manufacturer\'s owner\'s manual for more details.';

export const BlueprintCoverPage = (props: BlueprintCoverPageProps): React.ReactElement => {
	const {
		page,
		customerName,
		layoutDescription,
		designerName,
		creationDate,
		threeDImageUrl
	} = props;

	return (
		<BlueprintPageWrapper pageNumber={page.pageNumber}>
			<BlueprintPageHeader
				title=""
				pageNumber={page.pageNumber}
				customerName={customerName}
				layoutDescription={layoutDescription}
				designerName={designerName}
				creationDate={creationDate}
				threeDImageUrl={threeDImageUrl}
				showThumbnail={true}
			/>

			<div style={COVER_BODY_STYLE}>
				{/* Disclaimer — matches PDF pageIntroHeadingRed */}
				<div style={COVER_DISCLAIMER_STYLE}>
					<EditableText overrideKey='cover.disclaimer'>
						{DISCLAIMER_LINE_1}<br />
						{DISCLAIMER_LINE_2}<br />
						{DISCLAIMER_LINE_3}
					</EditableText>
				</div>

				{/* 3D Render — static image captured from the 3D viewport */}
				<div style={COVER_IMAGE_WRAPPER_STYLE}>
					{threeDImageUrl ? (
						<img
							data-blueprint-render="true"
							src={threeDImageUrl}
							alt="3D Kitchen Render"
							style={COVER_IMAGE_STYLE}
						/>
					) : (
						<div style={COVER_IMAGE_PLACEHOLDER_STYLE}>
							3D Perspective Render
						</div>
					)}
				</div>

				{/* Coyote Warning — matches PDF orangeBox style, always shown */}
				<div style={COVER_COYOTE_BOX_STYLE}>
					<EditableText overrideKey='cover.coyoteWarning'>
						{COYOTE_WARNING_TEXT}<br /><br />
						{COYOTE_WARNING_TEXT_2}
					</EditableText>
				</div>
			</div>

			<BlueprintPageFooter pageNumber={page.pageNumber} />
		</BlueprintPageWrapper>
	);
};
